import React from 'react';

import RangeSlider from '../../../RangeSlider';

import type { TieredRates } from '../../../../../utils/rateExtractor';

interface CardTypeRowProps {
	cardTypeName: string;
	rates: TieredRates;
	onRateChange: (tier: keyof TieredRates, value: number) => void;
}

export const CardTypeRow: React.FC<CardTypeRowProps> = ({
	cardTypeName,
	rates,
	onRateChange,
}) => {
	// Safety check: ensure rates object exists and has required properties
	const safeRates = rates || {
		qualified_rate: 0,
		qualified_per_item: 0,
		midqualified_rate: 0,
		midqualified_per_item: 0,
		nonqualified_rate: 0,
		nonqualified_per_item: 0,
	};

	return (
		<div className="grid grid-cols-7 gap-4 mb-6 items-center">
			<div className="font-medium col-span-1 text-gray-900">{cardTypeName}</div>

			{/* Qualified Column */}
			<div className="space-y-2 col-span-2">
				{/* Discount Rate Slider */}
				<div className="space-y-1">
					<RangeSlider
						label="Discount Rate"
						value={safeRates.qualified_rate}
						onChange={(value: number) => onRateChange('qualified_rate', value)}
						min={0}
						max={5}
						step={0.01}
						unit="%"
						precision={2}
					/>
				</div>
				{/* Authorization Fee Slider */}
				<div className="space-y-1">
					<RangeSlider
						label="Authorization Fee"
						value={safeRates.qualified_per_item}
						onChange={(value: number) =>
							onRateChange('qualified_per_item', value)
						}
						min={0}
						max={1}
						step={0.01}
						unit="$"
						precision={2}
					/>
				</div>
			</div>

			{/* Mid-Qualified Column */}
			<div className="space-y-2 col-span-2">
				{/* Discount Rate Slider */}
				<div className="space-y-1">
					<RangeSlider
						label="Discount Rate"
						value={safeRates.midqualified_rate}
						onChange={(value: number) =>
							onRateChange('midqualified_rate', value)
						}
						min={0}
						max={5}
						step={0.01}
						unit="%"
						precision={2}
					/>
				</div>
				{/* Authorization Fee Slider */}
				<div className="space-y-1">
					<RangeSlider
						label="Authorization Fee"
						value={safeRates.midqualified_per_item}
						onChange={(value: number) =>
							onRateChange('midqualified_per_item', value)
						}
						min={0}
						max={1}
						step={0.01}
						unit="$"
						precision={2}
					/>
				</div>
			</div>

			{/* Non-Qualified Column */}
			<div className="space-y-2 col-span-2">
				{/* Discount Rate Slider */}
				<div className="space-y-1">
					<RangeSlider
						label="Discount Rate"
						value={safeRates.nonqualified_rate}
						onChange={(value: number) =>
							onRateChange('nonqualified_rate', value)
						}
						min={0}
						max={5}
						step={0.01}
						unit="%"
						precision={2}
					/>
				</div>
				{/* Authorization Fee Slider */}
				<div className="space-y-1">
					<RangeSlider
						label="Authorization Fee"
						value={safeRates.nonqualified_per_item}
						onChange={(value: number) =>
							onRateChange('nonqualified_per_item', value)
						}
						min={0}
						max={1}
						step={0.01}
						unit="$"
						precision={2}
					/>
				</div>
			</div>
		</div>
	);
};
